import React from 'react';
import styles from './TokenClaimedModal.module.scss';
import { Modal } from 'react-bootstrap';
import closeIcon from '../../assets/icons/btn-close-X.svg';
import { useTranslation } from 'react-i18next';


const TokenClaimedModal = (props) => {
    const [t] = useTranslation();
    const { open, setOpen, tokens, type } = props;

    return (
        <Modal show={open} className={styles.token_modal}  centered dialogClassName={styles.token_modalDialog} onHide={() => setOpen(false)}
           contentClassName={`${styles.token_modalContent} ${styles[tokens.stylingName]}`}
        >
            <button className={styles.close_btn} onClick={()=> setOpen(false)}>
                <img src={closeIcon} alt="" />
            </button>
            <Modal.Body bsPrefix={styles.token_modalBody}>
                <div className={styles.bodyText}>
                    {tokens.stylingName === 'AttendanceDayBadge' || tokens.stylingName === 'CrazoMintPass' ?
                        <div className={`${styles.rewards_text} flex-column`}>
                            <span>{t('YOU_HAVE_GOT')} <span className={styles.highlight}>{tokens?.name}</span></span>
                            {tokens?.additionalReward && <span>&nbsp;<span>{tokens?.additionalReward ? t('AND_A') : ''} <span className={styles.highlight}>{tokens?.additionalReward}</span></span></span>}
                        </div> :
                        <div className={styles.rewards_text}>
                            <span>{t('YOU_HAVE_GOT')} {tokens?.value ? <><div className={styles.highlight}>{tokens?.value}</div> {t('TOWER_TOKENS')}</> : ''}</span>
                            {tokens?.type && <span>&nbsp;<span>{tokens?.value ? t('AND_A') : ''} <span className={styles.highlight}>{tokens?.name}</span></span></span>}
                        </div>
                    }
                    <span>{t('COME_BACK_TOMORROW')}</span>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export {TokenClaimedModal}
